import {FileExtensionEnum, MimeTypeEnum} from '../feed-form-const';

export const FEED_UPLOAD_TYPES = {
    extensions: [FileExtensionEnum.Csv, FileExtensionEnum.Xml, FileExtensionEnum.Json, FileExtensionEnum.Xlsx],
    mimeTypes: [MimeTypeEnum.TextCsv, MimeTypeEnum.TextXml, MimeTypeEnum.ApplicationJson, MimeTypeEnum.ApplicationXlsx],
};
